module.exports = __webpack_public_path__ + "img/activation-recharge.765d6f68.svg";